import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { INDAManagement } from '../../Interfaces/INDAManagement';
import { NDAManagementService } from '../../services/ndaManagement-services';
import { EvidenceNDADetailComponent } from './evidenceNDA-detail/evidenceNDA-detail.component';

@Component({
	selector: 'app-ndasmanagement-detail',
	templateUrl: './ndasmanagement-detail.component.html',
})
export class NdasmanagementDetailComponent implements OnInit {
	loading: boolean = false;
	listNDATypes: INDAManagement[];
	formGroup: FormGroup;
	hasNDATemplate: boolean = false;
	NDAManagement: INDAManagement = {
		pkndamanagment: 0,
		fkndamanagment: 0,
		ndamanagment: '',
		fkndatype: 0,
		ndatypename: '',
		available: false,
		creationdate: new Date(),
		strcreationdate: '',
		fkemployeecreator: 0,
		lastupdated: new Date(),
		strlastupdated: '',
		fkemployeeupdater: 0,
		employeecreatorname: '',
		employeeupdatername: '',
		username: '',
		fksite: 0,
	};
  max_characters: string = '';

	constructor(
		private dialogRef: MatDialogRef<NdasmanagementDetailComponent>,
		@Inject(MAT_DIALOG_DATA) public data: INDAManagement,
		private notificationService: NotificationService,
		private formBuilder: FormBuilder,
		private NDAManagementService: NDAManagementService,
		public translate: TranslateApplicationService,
		private dialog: MatDialog,
	) {
		this.formGroup = this.formBuilder.group({
			pkndamanagment: [
				data.pkndamanagment == null ? 0 : data.pkndamanagment,
				Validators.required,
			],
			txtndamanagment: [
				data.ndamanagment,
				[
					Validators.required,
					Validators.maxLength(80),
					Validators.pattern('.*[^ ].*'),
				],
			],
			cbfkndatype: [
				data.fkndatype == 0 ? null : data.fkndatype,
				Validators.required,
			],
			ndatemplate: [null, Validators.required],
		});

		// This statement makes the formGroup valid so you can update the information without having to load a template.
		if (data.pkndamanagment != 0) {
			this.formGroup.controls.ndatemplate.setValue(true);
		}
	}

	ngOnInit(): void {
		this.GetNDATypes();
		let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '80');
	}

	AddEvidence() {
		if (this.formGroup.controls.txtndamanagment.valid &&
			this.formGroup.controls.cbfkndatype.valid) 
		{
			this.NDAManagement.pkndamanagment = this.formGroup.controls.pkndamanagment.value;
			this.NDAManagement.ndamanagment = this.formGroup.controls.txtndamanagment.value;
			this.NDAManagement.fkndatype = this.formGroup.controls.cbfkndatype.value;
			const dialogRef = this.dialog.open(EvidenceNDADetailComponent, {
				data: this.NDAManagement,
			});
			dialogRef.afterClosed().subscribe((result) => {
				if (result) {
					this.dialogRef.close(true);
				}
				else{
					this.ErrorAlert(result.message);
				}
			});
		} else {
			this.Alert('Warning', 'WARNINGS.Empty_fields');
		}
	}

	GetNDATemplate() {
		this.loading = true;
		this.NDAManagementService.CreateNDAManagement(this.formGroup.value,).subscribe(
			(result: TransactionResult<INDAManagement[]>) => {
				this.loading = false;
				if (result.success) {
					this.formGroup.controls.ndatemplate.setValue(true);
				}
				else{
					this.ErrorAlert(result.message);
				}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

  GetNDATypes() {
    this.loading = true;
    let ndatype = this.formGroup.controls.cbfkndatype.value == null ? 0 : this.formGroup.controls.cbfkndatype.value;
    this.NDAManagementService.GetNDATypes(ndatype).subscribe(
		(result: TransactionResult<INDAManagement[]>) => {
			this.loading = false;
			if (result.success) {
				this.listNDATypes = result.data;
			}
			else{
				this.ErrorAlert(result.message);
			}
		},
		(error) => {
			this.ErrorAlert(error);
			this.loading = false;
		});
	}

	Save() {
		this.loading = true;
		if ( this.formGroup.controls.pkndamanagment.value != 0 &&
			 this.formGroup.valid ) 
		{
			this.NDAManagementService.UpdateNDAManagement(this.formGroup.value,).subscribe((
				result: TransactionResult<INDAManagement[]>) => {
          this.loading = false;
					if (result.success) {
						this.Alert('Success', 'COMPLETE');
						this.dialogRef.close(true);
					}
			},
			(error) => {
				this.ErrorAlert(error);
				this.loading = false;
			});
		}
	}
  
	Close() {
		this.dialogRef.close(true);
	}

	Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
	}

	ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
 	}
}
